<template>
  <div :title="tooltipText" class="info" @click="infoClicked()" @mouseover="infoClicked()">
   <i class="fa fa-info-circle info-icon" aria-hidden="true"></i>
   <span class="sr-only">Information about {{ fieldName }} field</span>
  </div>
</template>
<script>
 export default {
   props: ['tooltipText', 'fieldName'],
   methods: {
     infoClicked() {
       // eslint-disable-next-line no-undef
       $(".info").tooltip({
         position: {
           my : 'left center',
           at: 'right center',
         },
         tooltipClass: "info-tooltip",
       });
     }
   }
 }
</script>